import { ILocationItem } from '../reducers/formContextReducer';


export const requestContextLocations = "REQUEST_FETCH_FORM_CONTEXT_LOCATIONS_ACTIONS";
const successFetchContextLocations = "SUCCESS_FETCH_FORM_CONTEXT_LOCATIONS_ACTIONS";
const failureFetchContextLocations = "FAILURE_FETCH_FORM_CONTEXT_LOCATIONS_ACTIONS";


export interface IRequestFetchContextLocations {
    type: typeof requestContextLocations;
}

interface ISuccessFetchContextLocations {
    type: typeof successFetchContextLocations;
    payload: { locations: ILocationItem[] };
}

interface IFailureFetchContextLocations {
    type: typeof failureFetchContextLocations;
    payload: { error: Error };
}



export type IFormContextAction
    = IRequestFetchContextLocations
    | ISuccessFetchContextLocations
    | IFailureFetchContextLocations
    ;




export const createRequestFetchContextLocations = (): IRequestFetchContextLocations => ({
    type: requestContextLocations,
});

export const createSuccessFetchContextLocations = (locations: ILocationItem[]): ISuccessFetchContextLocations => ({
    type: successFetchContextLocations,
    payload: { locations },
});

export const createFailureFetchContextLocations = (error: Error): IFailureFetchContextLocations => ({
    type: failureFetchContextLocations,
    payload: { error },
});
